import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../shared';
import { Observable } from 'rxjs';
import { PgwFpxFormDtoModel } from '../../data-transfer-objects/pgw-fpx-form.model';

@Injectable({
  providedIn: 'root',
})
export class PgwFpxFormService extends BaseApiTemplateService<any> {
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'my/fpx';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'my/fpx';
    this.httpClient = http;
  }

  postInitForm(tenantCode : string,paymentChannelCodePart : string, txnHdrGuid : string,dtoObject: PgwFpxFormDtoModel, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/init-submit-form/${tenantCode}/${paymentChannelCodePart}/${txnHdrGuid}`
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
